<!--
 * @Author: cryi.liu
 * @Date: 2020-05-08 09:44:22
 * @LastEditTime: 2020-06-22 17:25:33
 * @Description: 题目信息
 -->
<template>
  <table class="question-info">
    <tbody>
      <tr>
        <td class="category">
          题库：
          <span>{{ info.libraryType }}</span>
        </td>
        <td class="category">
          难易度：
          <span>{{ info.level }}</span>
        </td>
        <td v-if="showRescoreBtn">
          <pss-button text="一键重新判分" @on-click="clickReScoreBtnHandler" />
        </td>
        <td v-if="needMedia">
          <pss-button text="完成" @on-click="clickDoneBtnHandler" />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'QuestionInfo',
  props: {
    libraryId: { type: String, required: true },
    needMedia: { type: Boolean, required: true },
    info: { type: Object, required: true },
    questionType: { type: String, required: true },
  },
  computed: {
    showRescoreBtn() {
      return !this.needMedia && this.questionType !== '简答';
    },
  },
  methods: {
    ...mapActions({
      setProcessingShowState: 'pageStore/invokeSetProcessingShowState',
    }),
    /**
     * 点击一键重新判分按钮处理函数
     */
    clickReScoreBtnHandler() {
      this.setProcessingShowState({ show: true });

      this.requestReScore()
        .then((result) => {
          alert(result.msg);
          this.setProcessingShowState({ show: false });
        })
        .catch((result) => {
          alert(result.msg);
          this.setProcessingShowState({ show: false });
        });
    },
    /**
     * 请求重新判分
     */
    requestReScore() {
      const params = {
        libraryId: this.libraryId,
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.libraryReScore(params);

        if (result.code === '200') {
          resolve(result);
        } else {
          reject(result);
        }
      });
    },
    /**
     * 点击完成按钮处理函数
     */
    clickDoneBtnHandler() {
      this.requestSaveStatus()
        .then(() => {
          alert('保存多媒体题目状态成功');
          this.$emit('repull-question-info');
        })
        .catch((result) => {
          alert(result.msg);
        });
    },
    /**
     * 请求保存题目状态
     */
    requestSaveStatus() {
      const params = {
        libraryId: this.libraryId,
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.librarySaveStatus(params);

        if (result.code === '200') {
          resolve(result);
        } else {
          reject(result);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.question-info {
  margin-bottom: 16px;
  width: 100%;

  > tbody {
    width: 100%;

    > tr {
      width: 100%;
      height: 42px;
      border-bottom: 1px solid #ddd;

      > td {
        vertical-align: middle;
        font-size: 12px;
        width: calc(100% / 3);

        &.category {
          font-weight: bold;

          > span {
            font-weight: normal;
          }
        }
      }
    }
  }
}
</style>
